import React from 'react';
import { FiFileText, FiHome, FiLayers, FiList, FiUser } from 'react-icons/fi';
import { RiBuildingLine, RiUserReceivedLine } from 'react-icons/ri';
import { MdEmail, MdNotificationsActive } from 'react-icons/md';
import { AiOutlineRobot } from 'react-icons/ai';

export const links = [
  {
    title: 'Dashboard',
    links: [
      {
        name: 'home',
        label: 'Home',
        icon: <FiHome />,
      },
    ],
  },
  {
    title: 'Administration',
    links: [
      {
        name: 'users',
        label: 'Job Seekers',
        icon: <FiUser />,
      },
      {
        name: 'companies',
        label: 'Companies',
        icon: <RiBuildingLine />,
      },
      {
        name: 'company-requests',
        label: 'Company Requests',
        icon: <RiUserReceivedLine />,
      },
      {
        name: 'cv-requests',
        label: 'Headhunt Pipeline',
        icon: <FiFileText />,
      },
      {
        name: 'applications',
        label: 'Applications',
        icon: <FiList />,
      },
      {
        name: 'job-postings',
        label: 'Job Postings',
        icon: <FiLayers />,
      },
      {
        name: 'cvs',
        label: 'CV Library',
        icon: <FiFileText />,
      },
      {
        name: 'email',
        label: 'Email Center',
        icon: <MdEmail />,
      },
      {
        name: 'push',
        label: 'Push Center',
        icon: <MdNotificationsActive />,
      },
      {
        name: 'try-ai',
        label: 'Try AI',
        icon: <AiOutlineRobot />,
      },
    ],
  },
];
